import { useEffect, useState } from 'react'
import { postWithAuth } from '../common'
import StatCard from './ui/StatCard'
export default function ClientRegistrationMetrics({ orgId, month }) {
    const [result, setResult] = useState(null)
    const [error, setError] = useState(false)
    useEffect(() => {
        let active = true
        setResult(null); setError(false)
        postWithAuth('fetchClientMetrics', { orgId, month }, { force: true }).then(response => {
            if (response?.err || typeof response?.data?.total !== 'number') throw new Error()
            if (active) setResult(response.data)
        }).catch(() => { if (active) setError(true) })
        return () => { active = false }
    }, [orgId, month])
    return <div className='srMetrics'>
        <StatCard label='Total clients added' value={result?.total ?? '—'} sublabel='Includes archived and deleted clients recorded by the client register.' />
        <StatCard label='Clients added this month' value={result?.added ?? '—'} sublabel={month + ' · Australia/Sydney'} />
        {error && <p role='status'>Client registration counts require the tracking service and existing-client backfill.</p>}
    </div>
}
